/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1PersonIdMutationResponse,
  DeleteApiV1PersonIdPathParams,
  DeleteApiV1PersonId401,
  DeleteApiV1PersonId404,
  DeleteApiV1PersonId500,
} from "../../types/personRegisterController/DeleteApiV1PersonId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1PersonId } from "../../clients/personRegisterController/deleteApiV1PersonId.ts";

export const deleteApiV1PersonIdMutationKey = () =>
  [{ url: "/api/v1/person/:id" }] as const;

export type DeleteApiV1PersonIdMutationKey = ReturnType<
  typeof deleteApiV1PersonIdMutationKey
>;

export function deleteApiV1PersonIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1PersonIdMutationKey();
  return mutationOptions<
    DeleteApiV1PersonIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1PersonId401 | DeleteApiV1PersonId404 | DeleteApiV1PersonId500
    >,
    { id: DeleteApiV1PersonIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1PersonId(id, config);
    },
  });
}

/**
 * @description Tenta excluir permanentemente. Se houver dependências, desativa a pessoa (soft delete). **(Requer Authorization para autenticação)**
 * @summary Excluir pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id}
 */
export function useDeleteApiV1PersonId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1PersonIdMutationResponse,
      ResponseErrorConfig<
        DeleteApiV1PersonId401 | DeleteApiV1PersonId404 | DeleteApiV1PersonId500
      >,
      { id: DeleteApiV1PersonIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1PersonIdMutationKey();

  const baseOptions = deleteApiV1PersonIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1PersonIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1PersonId401 | DeleteApiV1PersonId404 | DeleteApiV1PersonId500
    >,
    { id: DeleteApiV1PersonIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1PersonIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1PersonId401 | DeleteApiV1PersonId404 | DeleteApiV1PersonId500
    >,
    { id: DeleteApiV1PersonIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1PersonIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1PersonId401 | DeleteApiV1PersonId404 | DeleteApiV1PersonId500
    >,
    { id: DeleteApiV1PersonIdPathParams["id"] },
    TContext
  >;
}
